export enum CheckActionType {
  PAUSE = "Pause",
  RESUME = "Resume",
}
